/**
 * 管理UI設定の一元管理
 * 管理者のみがアクセスできる開発中機能の表示/非表示を制御する
 *
 * 【機能追加手順】
 * 1. ADMIN_UI_KEYS に新しいキーを追加
 * 2. 対象のVueコンポーネントで getAdminSetting('newKey') を参照
 */

// 管理UI設定キーの定義（機能追加時はここに1行追加）
export const ADMIN_UI_KEYS = {
  smileScenarioTabs: { label: 'スマイル/シナリオ分析タブ', default: false },
  bottomRiskCurve: { label: 'ページ下部リスクカーブ領域', default: false },
  // 例: smilePreset: { label: 'スマイルプリセット機能', default: false },
}

const STORAGE_KEY = 'admin_ui_settings'

/**
 * 設定値を取得
 * @param {string} key - ADMIN_UI_KEYS のキー
 * @returns {boolean}
 */
export function getAdminSetting(key) {
  try {
    const settings = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    return settings[key] ?? ADMIN_UI_KEYS[key]?.default ?? false
  } catch {
    return false
  }
}

/**
 * 設定値を保存
 * @param {string} key - ADMIN_UI_KEYS のキー
 * @param {boolean} value - 設定値
 */
export function setAdminSetting(key, value) {
  const settings = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  settings[key] = value
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings))
  // カスタムイベント発火（同一タブのVueコンポーネントに通知）
  window.dispatchEvent(new CustomEvent('adminUiSettingChanged', { detail: { key, value } }))
}

/**
 * 全設定を取得（モーダル初期化用）
 * @returns {Object} { key: boolean, ... }
 */
export function getAllAdminSettings() {
  const settings = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
  return Object.fromEntries(
    Object.entries(ADMIN_UI_KEYS).map(([key, def]) => [key, settings[key] ?? def.default])
  )
}
